/**
 * ProtectedImage
 * ─────────────────────────────────────────────────────────────────────────
 * A drop-in <img> for the surfaces where a picture is shown at its largest
 * (lightboxes, zoom stages, magnifier). It is exactly an <img>: same props,
 * same box, same CSS selectors (`Lightbox img { … }` still matches), same
 * ref. It only adds the per-element guards that ImageGuard applies
 * site-wide, so these surfaces stay protected even when the src is not a
 * Cloudinary URL (legacy imports, placeholders) or a listener is ever
 * removed.
 *
 * Use it through styled-components exactly like styled.img:
 *   const Hero = styled(ProtectedImage)` … `;
 */
import React, { forwardRef } from "react";

const stop = (event) => event.preventDefault();

const guardStyle = {
  WebkitUserDrag: "none",
  WebkitUserSelect: "none",
  userSelect: "none",
  WebkitTouchCallout: "none",
};

const ProtectedImage = forwardRef(function ProtectedImage(
  { style, onContextMenu, onDragStart, alt = "", ...rest },
  ref
) {
  return (
    <img
      ref={ref}
      alt={alt}
      draggable={false}
      data-protected-image=""
      onContextMenu={(event) => {
        stop(event);
        if (onContextMenu) onContextMenu(event);
      }}
      onDragStart={(event) => {
        stop(event);
        if (onDragStart) onDragStart(event);
      }}
      style={style ? { ...guardStyle, ...style } : guardStyle}
      {...rest}
    />
  );
});

export default ProtectedImage;
